const translations = {
  navigation: {
    table: 'Tabela',
    customers: 'Stranke',
    stats: 'Statistika',
    settings: 'Nastavitve',
    logout: 'Odjava'
  },
  label: {
    accept: 'Sprejmem',
    or: 'ali',
    first_name: 'Ime',
    last_name: 'Priimek',
    location: 'Kraj',
    address: 'Naslov',
    name: 'Naziv',
    person_name: 'Ime',
    phone: 'Telefon',
    email: 'E-pošta',
    birthday: 'Rojstni dan',
    city: 'Mesto',
    note: 'Opomba',
    password: 'Geslo',
    password_confirmation: 'Potrditev gesla',
    search: 'Iskanje',
    category: 'Kategorija',
    allCustomers: 'Vse stranke',
    organization: 'Ime podjetja',
    originalProfit: 'Original profit',
    chooseCurrency: 'Izberite valuto',
    chooseCountry: 'Izberite državo',
    businessPhone: 'Poslovni telefon',
    businessHours: 'Delovni čas',
    activate: 'Aktivirajte',
    deactivate: 'Deaktivirajte',
    today: 'Danes',
    categories: 'Kategorije',
    language: 'Jezik',
    stats: 'Statistika',
    employees: 'Zaposleni',
    account: 'Nalog',
    services: 'Storitve',
    materials: 'Materiali',
    profile: 'Profil',
    delete: 'Izbriši',
    edit: 'Spremeni',
    newEmail: 'Nova e-pošta',
    repeatPassword: 'Potrdi geslo',
    change: 'Spremeni',
    addEmployee: 'Dodaj zaposlenega',
    editEmployee: 'Uredi zaposlenega',
    addCustomer: 'Dodaj stranko',
    editCustomer: 'Uredi stranko',
    newCategory: 'Nova kategorija',
    about: 'Več o nas',
    country: 'Država',
    currency: 'Valuta',
    unit: 'Enota',
    quantity: 'Količina',
    price: 'Cena',
    discount: 'Popust',
    total: 'Skupaj',
    duration: 'Trajanje',
    pause: 'Odmor',
    material: 'Material',
    date: 'Datum',
    close: 'Zapri',
    noDataAvailable: 'Ni razpoložljivih podatkov',
    addMaterial: 'Dodaj material',
    editMaterial: 'Uredi material',
    addService: 'Dodaj storitev',
    editService: 'Uredi storitev',
    actions: 'Dejanja',
    service: 'Storitev',
    serviceName: 'Ime storitve',
    materialName: 'Ime materiala',
    h: 'h',
    min: 'min',
    noPause: 'Ni odmora',
    ml: 'ml',
    g: 'g',
    none: 'Brez',
    addCategory: 'Dodaj kategorijo',
    editCategory: 'Uredi kategorijo',
    requestedChange: 'Zahtevana sprememba',
    invitation: 'Povabi',
    view: 'Pregled',
    addAppointment: 'Dodaj termin',
    customer: 'Stranka',
    customerInfo: 'Podatki o stranki',
    customerHistory: 'Zgodovina obiskov',
    noCustomer: 'Ni strank',
    manageOrganization: 'Skrbnik',
    from: 'Od',
    to: 'Do',
    topWorkers: 'Najboljši zaposleni',
    perProfit: 'Po zaslužku',
    perCustomers: 'Po strankah',
    created: 'Izdelal',
    updated: 'Spremenil',
    profit: 'Zaslužek',
    appointments: 'Termini',
    notifications: 'Obvestila'
  },
  dateTime: {
    months: 'Jan_Feb_Mar_Apr_Maj_Jun_Jul_Avg_Sep_Okt_Nov_Dec',
    days: 'Pon_Tor_Sre_Čet_Pet_Sob_Ned'
  },
  days: {
    0: 'Ponedeljek',
    1: 'Torek',
    2: 'Sreda',
    3: 'Četrtek',
    4: 'Petek',
    5: 'Sobota',
    6: 'Nedelja'
  },
  button: {
    back: 'Vrnitev',
    login: 'Prijava',
    forgotPassword: 'Pozabljeno geslo',
    facebookLogin: 'Prijava s Facebookovim računom',
    facebookConnect: 'Poveži se s Facebookom',
    facebookDisconnect: 'Odjavi se s Facebookom',
    register: 'Registriraj se',
    upload: 'Naloži',
    remove: 'Odstrani',
    update: 'Posodobi',
    cancel: 'Prekliči',
    add: 'Dodaj',
    save: 'Shrani',
    submit: 'Pošlji',
    invite: 'Povabi',
    resendInvitation: 'Znova povabi',
    loadMore: 'Naloži več'
  },
  message: {
    cookiePolicy: 'Ta stran uporablja piškotke. Če nadaljujete brskanje po spletnem mestu, soglašate z njihovo uporabo.',
    somethingWentWrong: 'Ups! Prišlo je do napake',
    loginFailed: 'Napaka pri prijavi. Preverite svoje podatke',
    loginFailedEmailVerify: 'Napaka pri prijavi. Potrdite svojo e-pošto',
    login: 'Prijava',
    homepage: 'Domača stran',
    register: 'Registriraj se',
    forgottenPassword: 'Pozabljeno geslo',
    facebookFailed: 'Povezava s Facebookom ni uspela',
    checkYourEmail: 'Preverite svojo e-pošto za nadaljnja navodila',
    mailNotFound: 'Želena e-pošta ni bila najdena',
    saveSuccess: 'Podatki so shranjeni',
    saveFailed: 'Podatki niso shranjeni',
    removed: 'Odstranjeno',

    areYouSure: 'Ste prepričani?',
    removeEmployee: 'To dejanje bo izbrisalo zaposlenega',
    removeService: 'To dejanje bo izbrisalo storitev',
    removeMaterial: 'To dejanje bo izbrisalo material',
    removeCustomer: 'To dejanje bo izbrisalo stranko',
    removeCategory: 'To dejanje bo izbrisalo kategorijo',
    removeAppointment: 'To dejanje bo izbrisalo termin',
    badInvitation: 'Neizvršeno povabilo',
    invitationSent: 'Povabilo je poslano',
    joinedSalonize: 'Povezano s Salonize',
    emailChanged: 'E-poštni naslov je spremenjen',
    welcome: {
      welcomeSalonize: 'Dobrodošli v Salonize!',
      followSteps: 'Sledite navodilom.',
      firstStep: 'Najprej dodajte zaposlene. ',
      secondStep: 'Nato dodajte storitve '
    },
    no_notifications: 'Ni novih obvestil',
    hasBirthday: ' rojstni dan',
    passwordMismatch: 'Neujemanje gesla',
    emailTaken: 'E-poštni naslov je zaseden',
    missingLocation: 'Manjka kraj.',
    noServices: 'Ni izbranih storitev'
  },
  settings: {
    account: 'Налог',
    workers: 'Радници',
    services: 'Сервиси',
    materials: 'Материјали',
    profile: 'Профил'
  },
  languages: {
    en: 'English',
    rs: 'Српски',
    hr: 'Hrvatski',
    mk: 'Македонски',
    si: 'Slovenščina'
  },
  currencies: {
    eur: 'EUR',
    rsd: 'RSD',
    hrk: 'HRK',
    chf: 'CHF',
    gbp: 'GBP',
    usd: 'USD',
    all: 'ALL',
    bam: 'BAM',
    mkd: 'MKD'
  }
}

export default translations



// WEBPACK FOOTER //
// ./src/translations/si.js